<template>
    <div
        :id="`folder-${uuid}`"
        class="Folder"
        :class="{
            'Folder--dragging': isDragging,
            'Folder--busy': isBusy,
            'Folder--dropActive': isDropActive
        }">
        <router-link
            :to="href"
            class="Folder-link"
            @click.native.capture="handleLinkClick">
            <b-overlay
                :show="isBusy"
                rounded="lg"
                opacity="0.6"
                spinner-variant="primary"
                spinner-small spinner-type="grow">
                <div class="Folder-inner border rounded p-3"
                     :draggable="!isBusy"
                     @dragstart="onDrag($event)"
                     @dragend="onDragEnd($event)"
                     @drop.prevent="onDrop($event)"
                     @dragover.prevent
                     @dragenter.prevent="onDragEnter($event)"
                     @dragleave.prevent="onDragLeave($event)">
                    <fa-icon class="mr-2" :icon="['far', 'folder']" size="lg"/>
                    <span>{{ truncate(title, 22, '...') }}</span>
                </div>
            </b-overlay>
        </router-link>
    </div>
</template>

<script>
import helpers from "resources/js/helpers/index.js";

const dropActiveAttr = "drop-active";

export default {
    name: "Folder",
    mixins: [helpers],
    props: ["title", "uuid", "isBusy"],
    data() {
        return {
            isDragging: false,
            isDropActive: false
        }
    },
    computed: {
        href: function () {
            return `/my-list/folders/${this.uuid}`;
        }
    },
    methods: {

        handleLinkClick(evt) {
            if (this.isBusy) {
                evt.preventDefault();
                evt.stopPropagation();
            }
        },

        toggleDropActive(active = true) {
            this.isDropActive = active;
        },

        /**
         * Called when a folder starts to be dragged
         * @param evt
         */
        onDrag(evt) {
            this.isDragging = true;
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            evt.dataTransfer.setData('folderUUID', this.uuid);
            evt.dataTransfer.setData('sourceType', 'folder');
        },

        onDragEnd(evt) {
            this.isDragging = false;
        },

        /**
         * Called when the folder has a draggable dropped on it
         * @param evt
         */
        onDrop(evt) {
            this.toggleDropActive(false);

            if (this.isBusy) {
                return;
            }

            const sourceType = evt.dataTransfer.getData('sourceType');

            switch (sourceType) {
                case "folder": {
                    const droppedFolderUUID = evt.dataTransfer.getData('folderUUID');
                    if (droppedFolderUUID === this.uuid) {
                        return;
                    }
                    this.$emit('droppedOn', {
                        nativeEvent: evt,
                        sourceType,
                        source: droppedFolderUUID,
                        target: this.uuid
                    });
                    return;
                }
                case "entry": {
                    const entryId = evt.dataTransfer.getData('entryId');
                    this.$emit('droppedOn', {
                        nativeEvent: evt,
                        sourceType,
                        source: parseInt(entryId),
                        target: this.uuid
                    });
                    return;
                }
            }
        },

        onDragEnter(evt) {
            if (this.isDragging === false) {
                this.toggleDropActive(true);
            }
        },

        onDragLeave(evt) {
            this.toggleDropActive(false);
        }
    }
}
</script>

<style scoped lang="scss">
.Folder {
    display: block;
    white-space: nowrap;
}

.Folder-link {
    text-decoration: none;
}

.Folder-inner {
    overflow: hidden;

    &:hover {
        text-decoration: none;
        border-color: $brand !important;
    }
}

.Folder--dragging {
    .Folder-inner {
        background: $gray-100;
        box-shadow: inset 0 0 0 1px $brand;
    }
}

.Folder--dropActive {
    .Folder-inner {
        box-shadow: inset 0 0 0 2px $brand;
    }
}
</style>
